"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _userCenter = require("@/api/uc/userCenter");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'messTmpl',
  data: function data() {
    return {
      ucOrg: {
        orgId: null,
        orgName: null,
        createName: null,
        createTimeFormat: null,
        orgGroupName: null,
        legalPerson: null,
        name1: null,
        email1: null,
        mobile1: null
      },
      loading: false
    };
  },
  created: function created() {
    this.getUcOrgData();
  },
  methods: {
    getUcOrgData: function getUcOrgData() {
      var _this = this;
      this.loading = true;
      (0, _userCenter.queryOrgData)().then(function (res) {
        _this.ucOrg = res.data;
        _this.loading = false;
      }, function () {
        _this.loading = false;
      });
    },
    updateUcOrg: function updateUcOrg() {
      var _this2 = this;
      this.loading = true;
      (0, _userCenter.perfectOrgData)(this.ucOrg).then(function (res) {
        _this2.getUcOrgData();
      }, function () {
        _this2.loading = false;
      });
    }
  }
};